var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"context-menu"},[_c('ul',{staticClass:"context-menu__items"},[_c('li',{staticClass:"context-menu__item",on:{"click":_vm.fnregisterForm}},[_c('a',{staticClass:"context-menu__link"},[_vm._v(" In phiếu đăng ký ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }